





import { defineComponent } from '@vue/composition-api';

import PanelWithSpeakerEditor from '@/components/Speaker/PanelWithSpeakerEditor.vue';

const New = defineComponent({
  components: {
    PanelWithSpeakerEditor,
  },
  // setup() {},
});

export default New;
